import { useMemo } from "react"
import { Helmet } from "react-helmet-async"
import { useLocation, matchPath } from "react-router-dom"

const APP_NAME = "Bütçe Planlama Uygulaması"

const ROUTE_TITLES: { pattern: string; title: string }[] = [
  { pattern: "/parameters", title: "Sistem Parametreleri" },
  { pattern: "/messages", title: "Mesajlar" },
  { pattern: "/roles", title: "Roller" },
  { pattern: "/organizations", title: "Organizasyonlar" },
  { pattern: "/organizations/:orgId/*", title: "Organizasyonlar" },
  { pattern: "/budget-items", title: "Bütçe Kalemleri" },
  { pattern: "/budget-items/:itemId/*", title: "Bütçe Kalemleri" },
  { pattern: "/budget-templates", title: "Bütçe Şablonları" },
  { pattern: "/budget-templates/:tempId/*", title: "Bütçe Şablonları" },
  { pattern: "/budget-plans", title: "Bütçe Planı Girişi" },
  { pattern: "/tree-table", title: "Bütçe Veri Giriş Ekranı" },
]

function resolveTitle(pathname: string): string {
  for (const { pattern, title } of ROUTE_TITLES) {
    if (matchPath({ path: pattern, end: !pattern.endsWith("/*") }, pathname)) {
      return `${title} | ${APP_NAME}`
    }
  }
  return APP_NAME
}

export function PageTitle() {
  const location = useLocation()
  const title = useMemo(() => resolveTitle(location.pathname), [location.pathname])

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}
